import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import useMyMApi from '../hooks/useMyMApi';
import useWebContext from '../hooks/useWebContext';
import Preview, { previewModalSize } from '../pages/MyM906_Preview/Preview';
import { MyMLabel } from '../ui-elements/MyMLabel';
import { MyMLink } from '../ui-elements/MyMLink';
import { MyMModal } from '../ui-elements/MyMModal';
import { utility } from '../utility';
import { BoxFileFavorite } from './ContentsFavorite';
import { CopyDialog } from './CopyDialog';

/**
 * BoxFileRequestMenu Component
 */

// 2024.5.8 MyMine Version1.5対応 Modify Start
// 2025.3.5 MyMine Version2.1対応 Modify Start
const BoxFileRequestMenu = ({ screenId, fileId, isFavorite, callbackFavorite, setIsLoading, isHiddenFavorite, canShareContents, metadataId, listViewFlg, thumnailViewFlg }) => {
  // 2025.3.5 MyMine Version2.1対応 Modify End
  // 2024.5.8 MyMine Version1.5対応 Modify End

  const { controlSettings } = useWebContext(screenId);

  const apiRequest = useMyMApi(screenId);

  const [isModalOpen, setIsModalOpen] = useState(false);
  // 2025.3.5 MyMine Version2.1対応 Add Start
  const [isShareDialogOpen, setIsShareDialogOpen] = React.useState(false);
  const [shareUrl, setShareUrl] = React.useState(null);
  // 2025.3.5 MyMine Version2.1対応 Add End
  const [previewFileId, setPreviewFileId] = useState(false);
  const handleModalClose = () => setIsModalOpen(false);
  const queryparam = useParams();

  const onClickPreview = (e, fileId) => {
    setPreviewFileId(fileId);
    setIsModalOpen(true);
  }

  const onClickDownload = (e, fileId) => {
    setIsLoading(true);

    const downloadSuccessCallback = () => {
      setIsLoading(false);
    }

    const downloadFailedCallback = (result) => {
      setIsLoading(false);
    }

    apiRequest.download(`api/box-file/download?FileId=${fileId}`, downloadSuccessCallback, downloadFailedCallback);
  }

  // 2025.3.5 MyMine Version2.1対応 Modify Start
  const currentUrl = window.location.origin;
  const path = window.location.pathname.split('/');

  const onClickShare = () => {
    setIsLoading(true);

    const isDirectContents = listViewFlg || thumnailViewFlg;

    const paramObj = isDirectContents
      ? { FileId: fileId }
      : {
        ScreenIdList: [...new Set([queryparam.metadata_id ? path[path.length - 3] : screenId, screenId])].join(','),
        UrlMetadataId: queryparam.metadata_id,
        ContentsMetadataId: metadataId,
        FileId: fileId,
      };


    const successCallback = (result) => {
      setIsShareDialogOpen(true);
      setIsLoading(false);

      const basePath = '/MyM707/';
      setShareUrl(`${currentUrl}${process.env.REACT_APP_BASE_URL}${basePath}${result}`);
    };

    const failedCallback = () => {
      setIsLoading(false);
    };

    apiRequest.requestJson(
      `api/contents/encrypt-share-key?${utility.makeEncodeParameter(paramObj)}`,
      'GET',
      successCallback,
      failedCallback
    );
  };


  // 2025.3.5 MyMine Version2.1対応 Modify End

  /**
   * お気に入り(登録/解除)押下時処理
   */
  const onClickFavorite = () => {
    setIsLoading(true);
    const callbackSuccessFavorite = () => {
      callbackFavorite(fileId);
      setIsLoading(false);
    }
    const callbackFailedFavorite = () => {
      setIsLoading(false);
    }
    apiRequest.requestJson(`api/box-file/favorite`, 'POST', callbackSuccessFavorite, callbackFailedFavorite, { Key: fileId, UnFavorite: isFavorite })
  }

  return (
    // 2024.5.8 MyMine Version1.5対応 Modify Start
    <>
      <MyMLink onClick={(e) => { onClickPreview(e, fileId) }}>{controlSettings.LabelList.lnkPreview}</MyMLink>
      <MyMLabel component='span'>{controlSettings.LabelList.lblSeparate}</MyMLabel>
      <MyMLink onClick={(e) => { onClickDownload(e, fileId) }}>{controlSettings.LabelList.lnkDownload}</MyMLink>
      {
        !isHiddenFavorite &&
        <>
          <MyMLabel component='span'>{controlSettings.LabelList.lblSeparate}</MyMLabel>
          <BoxFileFavorite isFavorite={isFavorite} favoriteAction={onClickFavorite} unFavoriteAction={onClickFavorite} />
        </>
      }
      {/*2025.3.5 MyMine Version2.1対応 Add Start*/}
      {canShareContents &&
        <>
          <MyMLabel component='span'>{controlSettings.LabelList.lblSeparate}</MyMLabel>
          <ShareOutlinedIcon onClick={(e) => { onClickShare(e, fileId, metadataId) }} sx={{ cursor: 'pointer', color: '#77787B', fontSize: '20px' }} />
          <CopyDialog
            isOpen={isShareDialogOpen}
            onClose={() => { setIsShareDialogOpen(false) }}
            copyText={shareUrl}
            screenId={screenId}
          />
        </>
      }
      {/*2025.3.5 MyMine Version2.1対応 Add End*/}
      {isModalOpen && <MyMModal
        open={isModalOpen}
        onClose={handleModalClose}
        {...previewModalSize}
      >
        <Preview fileId={previewFileId} onPreviewFailed={handleModalClose} />
      </MyMModal>}
    </>
    // 2024.5.8 MyMine Version1.5対応 Modify End
  );
}
export default BoxFileRequestMenu;

